import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../Ihouse/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../Ihouse/assets/ts/_utils'
import {WithChildren} from '../../Ihouse/helpers'
import EditFoodForm from '../../Components/Forms/EditFoodForm'

const PrivateRoutes = () => {
  const TodaysBookings = lazy(() => import('../../Components/Tables/BookingsTable'))
  const Form = lazy(() => import('../../Components/Forms/Form1'))
  const FoodMenuTable = lazy(() => import('../../Components/Tables/FoodItemsTable'))
  const CategoryTable = lazy(() => import('../../Components/Tables/CategoryTable'))
  const SubCategoryTable = lazy(() => import('../../Components/Tables/SubCategoryTable'))
  const VouchersTable = lazy(() => import('../../Components/Tables/VouchersTable'))
  const TransactionTable = lazy(() => import('../../Components/Tables/TransactionTable'))
  const ContactTable = lazy(() => import('../../Components/Tables/ContactsTable'))
  const OrdersTable = lazy(() => import('../../Components/Tables/OrdersTable'))
  const TestimonialsTable = lazy(() => import('../../Components/Tables/TestimonialsTable'))
  const OrderPage = lazy(() => import('../../Components/OrderPage'))
  const ProfilePge = lazy(() => import('../../Components/Profile'))
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />

        <Route path='/EditFoodMenu/:id' element={<EditFoodForm />} />
        {/* Lazy Modules */}

        <Route
          path='/bookings/'
          element={
            <SuspensedView>
              <TodaysBookings />
            </SuspensedView>
          }
        />
        <Route
          path='/profile'
          element={
            <SuspensedView>
              <ProfilePge />
            </SuspensedView>
          }
        />
        <Route
          path='/categories/main'
          element={
            <SuspensedView>
              <CategoryTable />
            </SuspensedView>
          }
        />
        <Route
          path='/categories/sub'
          element={
            <SuspensedView>
              <SubCategoryTable />
            </SuspensedView>
          }
        />

        <Route
          path='/foodmenu'
          element={
            <SuspensedView>
              <FoodMenuTable />
            </SuspensedView>
          }
        />
        <Route
          path='/addFoodmenu'
          element={
            <SuspensedView>
              <Form />
            </SuspensedView>
          }
        />
        <Route
          path='/vouchers'
          element={
            <SuspensedView>
              <VouchersTable />
            </SuspensedView>
          }
        />

        <Route
          path='/TransactionTable'
          element={
            <SuspensedView>
              <TransactionTable />
            </SuspensedView>
          }
        />
        <Route
          path='/contacts'
          element={
            <SuspensedView>
              <ContactTable />
            </SuspensedView>
          }
        />
        <Route
          path='/orders'
          element={
            <SuspensedView>
              <OrdersTable />
            </SuspensedView>
          }
        />

        <Route
          path='/testimonials'
          element={
            <SuspensedView>
              <TestimonialsTable />
            </SuspensedView>
          }
        />

        <Route
          path='/order/:id'
          element={
            <SuspensedView>
              <OrderPage />
            </SuspensedView>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
